import { Backdrop, BackdropProps } from '@mui/material';
import { FC, memo } from 'react';
import { BluLoaderInterface } from './interface';
import './BluLoader.scss';

const BluLoader: FC<BluLoaderInterface> = memo(
  ({ open, CircularProps, sx, zIndex, ...rest }) => {
    return (
      <Backdrop
        {...rest}
        sx={{
          display: open ? undefined : 'none',
          zIndex: zIndex ?? 9999999999, // fallback se non specificato
          backgroundColor: 'transparent',
          ...sx,
        }}
        open
      >
        <div className="loader-bludata">
          <span className="loader-bludata__element"></span>
          <span className="loader-bludata__element"></span>
          <span className="loader-bludata__element"></span>
        </div>
      </Backdrop>
    );
  },
);

export default BluLoader;
